import { Fade, Tooltip } from "@mui/material";
import { tooltipLightStyles } from "../../styleUtils";
import { useTranslation } from "react-i18next";
import {
  formatDatetime,
  getByFieldValue,
  isEmptyList,
  isNullOrUndefined,
  logAnalyticsEvent,
} from "../../utils";
import { useMainDispatchContext } from "../../MainContext";
import { getUserInfo } from "../../userUtils";
import { getTurnaroundDetails, patchTurnaroundProfileClose } from "../../api";
import { ANALYTICS_EVENTS } from "../../constants";

function TurnaroundCloseButton(props) {
  const { t } = useTranslation();
  const dispatch = useMainDispatchContext();

  const { turnaroundInfo, airportTimezone, users } = props;

  const isClosed = !isNullOrUndefined(turnaroundInfo.closedAt);
  const closedByUser =
    !isNullOrUndefined(turnaroundInfo.closedByUserUuid) && !isEmptyList(users)
      ? getByFieldValue(users, "uuid", turnaroundInfo.closedByUserUuid)
      : null;
  const closedByUserInfo = !isNullOrUndefined(closedByUser)
    ? getUserInfo(closedByUser)
    : null;
  const closedByUserName = !isNullOrUndefined(closedByUserInfo)
    ? closedByUserInfo.fullName
    : t("system");

  async function handleConfirmClose() {
    dispatch({
      type: "setConfirmationProcessing",
      confirmationProcessing: true,
    });

    // Close the turnaround
    const result = await patchTurnaroundProfileClose(
      dispatch,
      turnaroundInfo?.originalProfile.uuid
    );
    if (result) {
      // Refresh the turnaround
      await getTurnaroundDetails(dispatch, { uuid: turnaroundInfo.uuid });

      // Completed message
      let dispatchMessage = `${t("saved_web", {
        name: turnaroundInfo.combinedFlightName,
      })}`;
      dispatch({
        type: "setAlertMessage",
        alertMessage: dispatchMessage,
      });

      logAnalyticsEvent(
        dispatch,
        ANALYTICS_EVENTS.TURNAROUNDS_DETAILS_CLOSE_TURNAROUND
      );
    }
    dispatch({
      type: "setConfirmation",
      confirmation: null,
    });
  }

  function handleButtonClick() {
    dispatch({
      type: "setConfirmation",
      confirmation: {
        message: (
          <TurnaroundCloseMessage
            turnaroundName={turnaroundInfo.combinedFlightName}
          />
        ),
        actionLabel: t("confirm_close"),
        actionOK: () => {
          handleConfirmClose();
        },
        actionCancel: () => {
          dispatch({
            type: "setConfirmation",
            confirmation: null,
          });
        },
      },
    });
  }
  return (
    <>
      {isClosed && (
        <Tooltip
          title={
            isClosed && (
              <div className="tooltip-content">
                {t("closed_at_web", {
                  value: formatDatetime(
                    turnaroundInfo.closedAt,
                    airportTimezone
                  ),
                  name: closedByUserName,
                })}
              </div>
            )
          }
          placement="top"
          componentsProps={tooltipLightStyles}
          TransitionComponent={Fade}
          TransitionProps={{ timeout: 500 }}
          enterDelay={1000}
          arrow
        >
          <div>
            <button className="secondary" disabled={true}>
              {t("closed")}
            </button>
          </div>
        </Tooltip>
      )}
      {!isClosed && (
        <button className="secondary" onClick={handleButtonClick}>
          {t("close_turnaround")}
        </button>
      )}
    </>
  );
}

function TurnaroundCloseMessage(props) {
  const { t } = useTranslation();
  const { turnaroundName } = props;
  return (
    <div className="turnaround-close-message">
      <div className="turnaround-close-message-header">{`${t(
        "close_turnaround"
      )}: ${turnaroundName}`}</div>
      <div>{t("confirm_close_note")}</div>
    </div>
  );
}

export default TurnaroundCloseButton;
